import { useState } from "react";
import { Button, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from "@material-ui/core";
import PostAddIcon from '@material-ui/icons/PostAdd'
import HeaderModal from "../../../global/headerModal";
import BackDrop from "./../../../global/BackDrop";
import ModalBase from "./../../../global/ModalBase";
import { FormularioReservaStyle } from "./style";
import { useFormik } from "formik";
import * as yup from "yup";
import useApi from "./../../../hooks/useAPI";
import { useCatPurchase } from "../../../hooks/useCatPurchase";
import { ToastMessage } from "../../../global/ToastMessage";
import { useDispatch } from "react-redux";
import { generarReservaAction, obtenerReservasAction } from "./../../../ducks/reservasDuck"
import { catTipoCompra } from "../../../constant/catTipoCompra"
import dayjs from 'dayjs'
import PickerMod from "../../../global/PickersMod";
const validationSchema = yup.object({
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Monto es requerido"),
});

const initialValues = {
    monto: 0
}

const ModalFormulario = (props) => {
    const {
        idCuenta = 0,
        idPaquete = 0,
        Referencia = "",
        open = true,
        setOpen = () => { },
        idMoneda = 0
    } = props;
    const dispatch = useDispatch()
    const [regreso, setRegreso] = useState(dayjs())
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const dataTipoCompra = useCatPurchase({ idPaquete: idPaquete })
    const classes = FormularioReservaStyle()
    const [load, setLoad] = useState(false)
    const [tipoMoneda, setTipoMoneda] = useState(idMoneda)
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSave(values)
        },
    })
    const handleChangeRegreso = (value) => {
        setRegreso(value)
    }
    const onSave = (values) => {
        setLoad(true)
        dispatch(generarReservaAction({
            idCuenta: idCuenta,
            idMoneda: tipoMoneda,
            idPaquete: idPaquete,
            idTipoCompra: catTipoCompra.Reserva,
            MontoProveedor: values.monto,
            FechaRegreso: dayjs(regreso).format('YYYY-MM-DD')

        })).then(Response => {
            setLoad(false)
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(obtenerReservasAction())
            handleClose()
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });

        })
    }

    const handleClose = () => {
        setOpen(false)
        setLoad(false)
        setTipoMoneda(idMoneda)
        formik.resetForm(initialValues);
    }
    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }
    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo={`Generar Reserva: #${Referencia}`}
            />
            {
                (!dataTipoCompra.nuevoItem) &&
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12}>
                        <div style={{ textAlign: "center" }}>
                            <h2>Aviso!</h2>
                            <p>Para agregar un nuevo item, se tiene que pagar los items actules</p>
                        </div>
                    </Grid>
                </Grid>
            }
            {
                (idMoneda === 0) &&
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12}>
                        <div style={{ textAlign: "center" }}>
                            <h2>Aviso!</h2>
                            <p>Este paquete no tiene moneda proveedor</p>
                        </div>
                    </Grid>
                </Grid>
            }
            {
                (dataTipoCompra.nuevoItem && idMoneda !== 0) &&
                <form onSubmit={formik.handleSubmit}>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="lTipoMoneda">Moneda proveedor</InputLabel>
                                <Select
                                    labelId="lTipoMoneda"
                                    id="STipoMoneda"
                                    name="tipoMoneda"
                                    value={tipoMoneda}
                                    defaultValue={idMoneda}
                                    onChange={handleSelecTipoMoneda}
                                    label="Moneda"
                                    disabled
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {catalogoMoneda.map((moneda, index) => (
                                        <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                            {`${moneda.Clave} - ${moneda.Descripcion}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="input-Monto"
                                label="Monto"
                                type="text"
                                variant="outlined"
                                name="monto"
                                value={formik.values.monto}
                                onChange={formik.handleChange}
                                error={formik.touched.monto && Boolean(formik.errors.monto)}
                                helperText={formik.touched.monto && formik.errors.monto}
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <PickerMod
                                id={"Fecha-de-regreso"}
                                label={"Fecha de regreso"}
                                disablePast={false}
                                disableFuture={false}
                                selectedDate={regreso}
                                setSelectedDate={handleChangeRegreso}
                            />
                        </Grid>

                    </Grid>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12} className={classes.modalBotonesCenter}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.modalBoton}
                            >
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                    <BackDrop open={load} />
                </form>
            }
        </ModalBase>
    )
}

const FormularioItem = (props) => {
    const { idCuenta, idPaquete, Referencia, idMoneda, disabled = false } = props
    const [open, setOpen] = useState(false)
    const onClick = () => {
        setOpen(true)
    }
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={onClick} endIcon={<PostAddIcon />} disabled={disabled}>
                Reservar
            </Button>
            <ModalFormulario
                idCuenta={idCuenta}
                idPaquete={idPaquete}
                Referencia={Referencia}
                idMoneda={idMoneda}
                open={open}
                setOpen={setOpen}
            />
        </div>
    )
}
export default FormularioItem